import * as React from "react";
import { Input, InputNumber, DatePicker,Tooltip,Select,Button,Icon,Upload,message } from 'antd';
import SmallTools from "widget/smallTools";
import moment from "moment";
import _ from "lodash";
import { CopyToClipboard } from "react-copy-to-clipboard";
const Option = Select.Option;


interface Data {
  OrderInfo: any;
  data: any;
  updateDataValue:any;
  ErrorInfo:any;
  readonly:any;
  getQNConfig:any;
}

class orderInfo extends React.Component<Data> {
  state = {
    OrderInfo:[],
    data:{},
    readonly:{},
    token:'',
    url:'',
    files:[],
    ErrorInfo:{},
  };

  constructor(props: Data) {
    super(props);
  }
  // 比较两个对象的值是否相等 object:新值 base:旧值
  difference(object, base) {
    function changes(object, base) {
      return _.transform(object, function(result, value, key) {
        if (!_.isEqual(value, base[key])) {
          result[key] =
            _.isObject(value) && _.isObject(base[key])
              ? changes(value, base[key])
              : value;
        }
      });
    }
    return changes(object, base);
  }

  shouldComponentUpdate(nextProps: any, prevState: any) {
    if(!nextProps.OrderInfo){
      return false;
    }
    const keys = Object.keys(
      this.difference(nextProps.OrderInfo, this.state.OrderInfo)
    );
    const keysErro = Object.keys(
      this.difference(nextProps.ErrorInfo, this.state.ErrorInfo)
    );
    console.log("aaa",keysErro)
    if (keys.length > 0 || keysErro.length > 0) {
      this.setState({
        OrderInfo: nextProps.OrderInfo,
        data:nextProps.data,
        readonly:nextProps.readonly,
        ErrorInfo:nextProps.ErrorInfo,
      });
      return true;
    }
    /*if (prevState.OrderInfo.length != nextProps.OrderInfo.length) {
      this.setState({
        OrderInfo: nextProps.OrderInfo,
        data:nextProps.data,
        readonly:nextProps.readonly,
      });
      return false;
    }*/
    return true;
  }
  
  mapRadio = (list) =>{
      return(list.map((item) =>{
          return(<Option key={item}>{item}</Option>);
      }))
  }
  
  componentDidMount(){
    this.getToken();
  }

  onOk= () =>{
    message.success("复制成功");
  }

  getToken= () => {
    const param: any = {
    }; 
    this.props.getQNConfig({
      ...param,
      callback: (data) => {
        this.setState({
          token:data.token,
          url:data.url,
        }); 
      //console.log(data);     
      }
     });     
  }

  onChange = (id,value) =>{
      console.log(id,value)
      if(value instanceof Object){
         console.log(value.target.value)
         this.props.updateDataValue({id:id,value:value.target.value});
      }else{
         this.props.updateDataValue({id:id,value:value});
      }    
  }
  onChangeDate = (id,date,dateString) =>{
       this.props.updateDataValue({id:id,value:dateString});   
  }
  onChangeJiesong = (id,keys,items,value) => {
    let itemlist = [];
    if(items.length == 1){
      
    }
    itemlist = (items.map((item,key) =>{
        if(keys == key){
            return value.target.value;
        }else{
            return item;
        }           
    }))
    this.props.updateDataValue({id:id,value:itemlist});
  }
  
  onRemove = (id,file) => {
    console.log(777777777777777,id,file,this.state.data[id])
  }
  
  upload = (id,event) => {
    console.log(event);  
    let data = event.fileList;
    const listItems = data.map((item) =>{
     if(item.response){
       return({
         'name':item.name,
         'url':this.state.url+'/'+item.response['key'],
         'status':item.status,
         'uid':item.uid,
       });
     }else{
      return({
        'name':item.name,
        'url':item.url,
        'status':item.status,
        'uid':item.uid,
      });
     }
    }); 
    console.log(111,listItems)
    this.props.updateDataValue({id:id,value:listItems}); 
    let items = this.state.data;
    items[id]=listItems;
    this.setState({
      data:items
    }); 
 }

 container=()=>{
    //console.log(document.getElementsByTagName("div"))
    return document.getElementsByTagName("div")[91]
 } 
  
  creatFrom = () => {
    //this.getToken(); 
    
    const listItems = this.state.OrderInfo.map((item,key) => {
      //let classTag = 'feild'+item['id'];
      switch(item['f_type']){
          case 'num':
            return(<li key={item['id']}><label>{item['ch_name']}</label><div className='li-right'><Tooltip getPopupContainer={this.container}  visible={this.state.ErrorInfo[item['id']] ? true : false} placement="right"  title={this.state.ErrorInfo[item['id']] ? this.state.ErrorInfo[item['id']][0] :''}><InputNumber disabled={this.state.readonly[item['id']] ? true : false} max={item['max']} min={0}  value={this.state.data[item['id']]}   onChange={this.onChange.bind(this,item['id'])}   /></Tooltip></div></li>)
          case 'text':
            if(item['id'] == '7'){
              return(<li key={item['id']}><label>{item['ch_name']}</label><div className='li-right'><Tooltip getPopupContainer={this.container}  visible={this.state.ErrorInfo[item['id']] ? true : false} placement="right"  title={this.state.ErrorInfo[item['id']] ? this.state.ErrorInfo[item['id']][0] :''}><Input disabled={this.state.readonly[item['id']] ? true : false}  value={this.state.data[item['id']]} placeholder=""  onChange={this.onChange.bind(this,item['id'])} /></Tooltip></div>&nbsp;&nbsp;<CopyToClipboard text={this.state.data[item['id']]}><span onClick={this.onOk}><Icon type="copy" /></span></CopyToClipboard></li>)
            }else{
              return(<li key={item['id']}><label>{item['ch_name']}</label><div className='li-right'><Tooltip getPopupContainer={this.container}  visible={this.state.ErrorInfo[item['id']] ? true : false} placement="right"  title={this.state.ErrorInfo[item['id']] ? this.state.ErrorInfo[item['id']][0] :''}><Input disabled={this.state.readonly[item['id']] ? true : false}  value={this.state.data[item['id']]} placeholder=""  onChange={this.onChange.bind(this,item['id'])} /></Tooltip></div></li>)
            }
          case 'number':
            return(<li key={item['id']}><label>{item['ch_name']}</label><div className='li-right'><Tooltip getPopupContainer={this.container}  visible={this.state.ErrorInfo[item['id']] ? true : false} placement="right"  title={this.state.ErrorInfo[item['id']] ? this.state.ErrorInfo[item['id']][0] :''}><Input disabled={this.state.readonly[item['id']] ? true : false} value={this.state.data[item['id']]} placeholder=""   onChange={this.onChange.bind(this,item['id'])} /></Tooltip></div></li>)
          case 'jieren':
            return(
            <li key={item['id']}><label>{item['ch_name']}</label><div className='li-right'>
            <div className="xinming">
            <Tooltip getPopupContainer={this.container}  visible={this.state.ErrorInfo[item['id']] ? true : false} placement="right"  title={this.state.ErrorInfo[item['id']] ? this.state.ErrorInfo[item['id']][0] :''}>
            <Input disabled={this.state.readonly[item['id']] ? true : false}  className="xin" value={this.state.data[item['id']][0]}  onChange={this.onChangeJiesong.bind(this,item['id'],0,this.state.data[item['id']])}  placeholder=""  />
            <Input disabled={this.state.readonly[item['id']] ? true : false}  className="ming" value={this.state.data[item['id']][1]} onChange={this.onChangeJiesong.bind(this,item['id'],1,this.state.data[item['id']])}  placeholder=""  />
            </Tooltip>
            </div>
            </div></li>
          )
          case 'calender':
           if(item['value'] == '' || !this.state.data[item['id']]){
            return( <li key={item['id']}><Tooltip placement="top"  title={item['ch_name']}><label>{item['ch_name']}</label></Tooltip><div className='li-right'><Tooltip getPopupContainer={this.container}  visible={this.state.ErrorInfo[item['id']] ? true : false} placement="right"  title={this.state.ErrorInfo[item['id']] ? this.state.ErrorInfo[item['id']][0] :''}><DatePicker placeholder='请选择时间' disabled={this.state.readonly[item['id']] ? true : false} onChange={this.onChangeDate.bind(this,item['id'])}  /></Tooltip></div></li>)
           }else{
              const Date = moment(this.state.data[item['id']],'YYYY-MM-DD HH:mm:ss');
              return( <li key={item['id']}><Tooltip placement="top"   title={item['ch_name']}><label>{item['ch_name']}</label></Tooltip><div className='li-right'><Tooltip getPopupContainer={this.container}  visible={this.state.ErrorInfo[item['id']] ? true : false} placement="right"  title={this.state.ErrorInfo[item['id']] ? this.state.ErrorInfo[item['id']][0] :''}><DatePicker placeholder='请选择时间' disabled={this.state.readonly[item['id']] ? true : false}  value={Date} onChange={this.onChangeDate.bind(this,item['id'])}  /></Tooltip></div></li>)
          }
          case 'calendertime':
            if(item['value'] == '' || !this.state.data[item['id']]){
              return( <li key={item['id']}><Tooltip  placement="top"   title={item['ch_name']}><label>{item['ch_name']}</label></Tooltip><div className='li-right'><Tooltip getPopupContainer={this.container}  visible={this.state.ErrorInfo[item['id']] ? true : false} placement="right"  title={this.state.ErrorInfo[item['id']] ? this.state.ErrorInfo[item['id']][0] :''}><DatePicker placeholder='请选择时间' disabled={this.state.readonly[item['id']] ? true : false}   showTime format="YYYY-MM-DD HH:mm:ss" onChange={this.onChangeDate.bind(this,item['id'])}  /></Tooltip></div></li>)
            }else{
              const Datetime = moment(this.state.data[item['id']],'YYYY-MM-DD HH:mm:ss');
              return( <li key={item['id']}><Tooltip placement="top"  title={item['ch_name']}><label>{item['ch_name']}</label></Tooltip><div className='li-right'><Tooltip getPopupContainer={this.container}  visible={this.state.ErrorInfo[item['id']] ? true : false} placement="right"  title={this.state.ErrorInfo[item['id']] ? this.state.ErrorInfo[item['id']][0] :''}><DatePicker placeholder='请选择时间' disabled={this.state.readonly[item['id']] ? true : false}  showTime format="YYYY-MM-DD HH:mm:ss" value={Datetime}  onChange={this.onChangeDate.bind(this,item['id'])}  /></Tooltip></div></li>)
            } 
          case 'radio':
            const options = this.mapRadio(item['rvalue']);
            return(<li key={item['id']}><label>{item['ch_name']}</label><div className='li-right'><Tooltip getPopupContainer={this.container}  visible={this.state.ErrorInfo[item['id']] ? true : false} placement="right"  title={this.state.ErrorInfo[item['id']] ? this.state.ErrorInfo[item['id']][0] :''}><Select disabled={this.state.readonly[item['id']] ? true : false} value={this.state.data[item['id']]} onChange={this.onChange.bind(this,item['id'])} showSearch optionFilterProp="children" >{options}</Select></Tooltip></div></li>);   
          case 'upload':
            const data = {
              'token':this.state.token,
            };
            
            // tslint:disable-next-line:jsx-no-lambda
            return(<li className='li-right-up' key={item['id']}><label>{item['ch_name']}</label><div className='li-right-upload'><Tooltip getPopupContainer={this.container}  visible={this.state.ErrorInfo[item['id']] ? true : false} placement="right"  title={this.state.ErrorInfo[item['id']] ? this.state.ErrorInfo[item['id']][0] :''}><Upload  disabled={this.state.readonly[item['id']] ? true : false} onChange={this.upload.bind(this,item['id'])} action="//upload.qiniup.com" name='file' data={data} fileList={this.state.data[item['id']]}><Button disabled={this.state.readonly[item['id']] ? true : false}><Icon type="upload" />{this.state.readonly[item['id']] ? '不可上传' : '上传'}</Button></Upload></Tooltip></div></li>);                                    
          default:
            return('')  
       }
      })

    return <React.Fragment>{listItems}</React.Fragment>;
  };

  render() {
    
    if(this.state.OrderInfo.length == 0){
      return false;
    }else{
      return (
        <td>
        <div className='order-info'>
        <ul >
        <SmallTools
            content={this.creatFrom()}
            isOpenEnlarge={false}
            isOpenFieldDrawer={false}
        />
        </ul>  
        </div> 
        </td>
      );
    }
  }
}

export default orderInfo
